import { useRecoilState } from 'recoil';
import {
  DEFAULT_MODAL_CONFIRM_STATE,
  ModalConfirmState,
  modalConfirmState
} from '#states/atoms/modalConfirmState';

export function useModalConfirm() {
  const [state, setModal] = useRecoilState(modalConfirmState);

  const openModalConfirm = (state: Omit<ModalConfirmState, 'isVisible'>) => {
    setModal({ isVisible: true, ...state });
  };

  const closeModalConfirm = () => {
    setModal(DEFAULT_MODAL_CONFIRM_STATE);
  };

  return { ...state, openModalConfirm, closeModalConfirm };
}
